<div bsModal #settingsModal="bs-modal" class="eup-modal modal fade" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">
                    <button logClick id="btn-hide-settings" type="button" class="close close-sign" (click)="closeSettings()">
                        &times;
                    </button>
                    {{'Settings.Settings_Title' | translate }}
                </h3>
            </div>
            <div class="modal-body">
                <section class="row">
                    <h4 class="col-sm-12">
                        {{'Settings.Computer_Settings' | translate }}
                    </h4>
                    <div logClick id="show-localization" class="clickable col-sm-2" (click)="showLocalizationSettings()">
                        <svg class="svg-localization48 svg-localization48-dims"></svg>
                        <span class="settingsLinkText">{{'Settings.Localization' | translate }}</span>
                    </div>
                    <div logClick id="show-my-account" class="clickable col-sm-2" (click)="showLoginSettings()">
                        <svg class="svg-loginSettings40 svg-loginSettings40-dims"></svg>
                        <span class="settingsLinkText">
                            <div *ngIf="(isExternalProvider$ | async); else loginTemplate">
                                {{ 'Settings.ResetPassword' | translate }}
                            </div>
                            <ng-template #loginTemplate>
                                {{ 'Settings.Login' | translate }}
                            </ng-template>
                        </span>
                    </div>
                </section>
                <section class="row">
                    <h4 class="col-sm-12">
                        {{'Settings.User_Settings' | translate }}
                    </h4>
                    <div logClick id="show-rx-settings" class="clickable col-sm-2" (click)="showRxSettings()" *ngIf="shouldShowRxSettings">
                        <svg class="svg-rxSettings40 svg-rxSettings40-dims"></svg>
                        <span class="settingsLinkText">{{'Settings.Rx_Settings' | translate }}</span>
                    </div>
                    <div logClick id="show-export-settings" class="clickable col-sm-2" (click)="showExportSettings()" *ngIf="allowExportSettings">
                        <svg class="svg-exportSettings50 svg-exportSettings50-dims"></svg>
                        <span class="settingsLinkText">{{'Settings.Export_Settings' | translate }}</span>
                    </div>
                    <div *ngIf="isWeChatSharingEnabled"
                        logClick
                        id="show-account-pairing-settings" 
                        class="clickable col-sm-2" 
                        (click)="showAccountPairingSettings()">
                        <svg class="svg-accountPairingSettings40 svg-accountPairingSettings40-dims accountPairingSettingsIcon"></svg>
                        <span class="settingsLinkText">{{'Settings.Account_Pairing' | translate }}</span>
                    </div>
                    <div *ngIf="isNotificationsEnabled"
                        logClick
                        id="show-notifications-settings" 
                        class="clickable col-sm-2" 
                        (click)="showNotificationsSettings()">
                        <svg class="svg-notificationsSettings40 svg-notificationsSettings40-dims"></svg>
                        <span class="settingsLinkText">{{'Settings.Notifications' | translate }}</span>
                    </div>
                    <div *ngIf="isCrownAISettingsEnabled"
                        logClick
                        id="show-design-suite-settings" 
                        class="clickable col-sm-2" 
                        (click)="showCrownAISettings()">
                        <svg class="crown-ai-settings-icon"></svg>
                        <span class="settingsLinkText">{{'CrownAI.DesignSuite' | translate }}</span>
                    </div>
                </section>
                <section class="row" *ngIf="isSystemSettingsEnabled">
                    <h4 class="col-sm-12">
                        {{'Settings.System_Settings' | translate }}
                    </h4>
                    <div logClick id="show-system-information" class="clickable col-sm-2" (click)="showScannerInformation()">
                        <svg class="svg-systemInformation40 svg-systemInformation40-dims"></svg>
                        <span class="settingsLinkText">{{'Settings.Scanners_Title' | translate }}</span>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>
<eup-rxSettings id="modal-rx-settings"></eup-rxSettings>
<eup-localizationSettings id="modal-localization-settings"></eup-localizationSettings>
<eup-loginSettings id="modal-login-settings"></eup-loginSettings>
<eup-scannerSettings id="modal-scanner-settings"></eup-scannerSettings>
<eup-exportSettings id="modal-export-settings"></eup-exportSettings>
<eup-account-pairing-settings-modal id="account-pairing-settings"></eup-account-pairing-settings-modal>
<eup-notifications-settings-modal id="modal-notifications-settings"></eup-notifications-settings-modal>
<eup-crown-ai-settings-modal *ngIf="isCrownAISettingsEnabled" id="modal-crown-ai-settings"></eup-crown-ai-settings-modal>
